export default __webpack_public_path__ + "static/media/donut_small.8cf42b63.svg";